import React, { createContext, useState } from 'react';
import { AlertProps } from '@material-ui/lab/Alert';
import { useCallbackOne } from 'use-memo-one';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';
import { getId } from '../../utils/idForListItem';

interface IOptions {
  severity?: AlertProps['severity'];
  message?: string;
  title?: string;
  noTitle?: boolean;
}
export interface ISnack {
  severity: AlertProps['severity'];
  message?: string;
  title?: string;
  id: string;
}

interface ISnackMessageValues {
  snacks: ISnack[];
  push: (options: IOptions) => void;
  pop: (id: string) => void;
}

const initialSnackMessageValues = {
  snacks: [],
  push: () => null,
  pop: () => null,
};

export const SnackMessageContext = createContext<ISnackMessageValues>(initialSnackMessageValues);

export const SnackMessageProvider = ({ children }: { children: React.ReactNode }) => {
  const [snacks, setSnacks] = useState<ISnack[]>([]);

  const { t } = useTranslation();

  const push = useCallbackOne(({ severity, message, title, noTitle }: IOptions) => {
    let titleForSnack = '';
    if (title) {
      titleForSnack = title;
    } else if (severity) {
      titleForSnack = t(tPaths.snack.severity(severity));
    } else {
      titleForSnack = t(tPaths.snack.severity('success'));
    }
    if (noTitle) {
      titleForSnack = '';
    }

    const snack: ISnack = {
      severity,
      message,
      title: titleForSnack,
      id: getId(),
    };
    setSnacks((cv) => [...cv, snack]);
  }, []);

  const pop = useCallbackOne((id) => setSnacks((cv) => cv.filter((snack) => snack.id !== id)), [
    snacks,
  ]);

  return (
    <SnackMessageContext.Provider
      value={{
        snacks,
        push,
        pop,
      }}
    >
      {children}
    </SnackMessageContext.Provider>
  );
};
